<template>
    <base-form-control v-bind="formControlAttributes" @clear-clicked="clear">
        <slot name="prepend"></slot>
        <input v-on="listeners" v-bind="controlAttributes" :disabled="disabled" :value="model" type="text" class="control"/>
        <slot name="append"></slot>
    </base-form-control>
</template>

<script>
import BaseFormControl from './BaseFormControl';
import conformToMask from '../utils/mask/text-mast';
import BaseInput from './BaseInput';
import { stringMaskToRegExpMask } from '../utils/mask/convert';

export default {
    name       : 'form-mask-input',
    components : { BaseFormControl },
    extends    : BaseInput,
    data () {
        return { actualMask : '' };
    },
    props : {
        mask : { type : String, required : true }
    },
    created () {
        this.actualMask = stringMaskToRegExpMask(this.mask);
    },
    methods : {
        updateValue (evt) {
            let value;
            const target = evt.target;
            if (evt && target && target.value) {
                value = target.value;
            }
            let conformedValue = conformToMask(value, this.actualMask, { guide : false });
            conformedValue = conformedValue.conformedValue || '';

            if (conformedValue !== value) {
                target.value = conformedValue;
            }

            if (conformedValue !== this.model) {
                this.model = conformedValue;
                this.$emit('input', conformedValue);
            }
        }
    }

};
</script>
